/**
 * NostockProductDialog Component
 */
(function () {

    'use strict';

    /**
     * Render NostockProductDialog
     * @name noStockProductDialogCtrl
     * @type ItxNotockProductDialogCmpCtrl
     */
    var ItxNostockProductDialogCmp = {
        bindings: {
            product: '<'
        },
        controller: ItxNostockProductDialogCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxNostockProductDialog.html'
    };

    /** Public */
    angular.module('itxApp.common')
        .component('itxNostockProductDialog', ItxNostockProductDialogCmp);

    ItxNostockProductDialogCmpCtrl.$inject = [];

    function ItxNostockProductDialogCmpCtrl() {

        var _this = this;

        _this.$onInit = function () {};
    }

})();
